//#region imports

import { Box, Button, DialogActions, Grid, TextField, Typography } from '@mui/material';
import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react';
import * as Yup from "yup";
import { cfpBaseUrl, ptwBaseUrl, ptwToken } from '../../../network/urls';

import { Backdrop, CircularProgress } from '@mui/material';
import { documentExtensions } from '../../../utils/PortalName';
import "../../GeneralServices/NewConnection/NewConnectionForm.scss";
//jspdf
import { jsPDF } from "jspdf";
import "jspdf-autotable";
//jsbarcode
import CloseIcon from '@mui/icons-material/Close';
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import JsBarcode from "jsbarcode";
import FESCOWaterMark from '../../../images/DiscosWater/fesco-watermark.png';
import GEPCOWaterMark from '../../../images/DiscosWater/gepco-watermark.png';
import HAZECOWaterMark from '../../../images/DiscosWater/hazeco-watermark.png';
import HESCOWaterMark from '../../../images/DiscosWater/hesco-watermark.png';
import IESCOWaterMark from '../../../images/DiscosWater/iescowatermark.png';
import LESCOWaterMark from '../../../images/DiscosWater/lescowatermark.png';
import MEPCOWaterMark from '../../../images/DiscosWater/mepcco-watermark.png';
import PESCOWaterMark from '../../../images/DiscosWater/pesco-watermark.png';
import QESCOWaterMark from '../../../images/DiscosWater/qesco-watermark.png';
import SEPCOWaterMark from '../../../images/DiscosWater/sepco-watermark.png';
import TESCOWaterMark from '../../../images/DiscosWater/tesco-watermark.png';
import pdfIcon from "../../../images/pdfIcon.png";

import DoneIcon from '@mui/icons-material/Done';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import CustomerInformationCard from '../../../components/CustomerInformationCard/CustomerInformationCard';
import Error from '../../../components/error/error';
import StepProgressBar from '../../../components/StepProgressBarForm/StepProgressBar';
import FESCOLOGO from "../../../images/DISCO Logos/FESCO.png";
import GEPCOLOGO from "../../../images/DISCO Logos/GEPCO.png";
import HESCOLOGO from "../../../images/DISCO Logos/HESCO.png";
import IESCOLOGO from "../../../images/DISCO Logos/IESCO.png";
import LESCOLOGO from "../../../images/DISCO Logos/LESCO.png";
import MEPCOLOGO from "../../../images/DISCO Logos/MEPCO.png";
import PESCOLOGO from "../../../images/DISCO Logos/PESCO.png";
import QESCOLOGO from "../../../images/DISCO Logos/QESCO.png";
import SEPCOLOGO from "../../../images/DISCO Logos/SEPCO.png";
import TESCOLOGO from "../../../images/DISCO Logos/TESCO.png";
import SUNDARLOGO from "../../../images/discologos/sundar-logo.png";
import { addBusinessDays, companyShortName, dBillAPI, getMeterType, getPermissions, getPhase, getRelevantCFCCode, handleFileUpload, isImage, isPdf, numberFormatting, subDivAPI, subdivisionName } from '../../../services/Functions';

import HAZECOLOGO from "../../../images/DISCO Logos/HAZECO.jpg";
import pitcLogo from '../../../images/pitc.png';

import moment from 'moment';
//#endregion

const AmendBill2636Form = () => {
  //#region initial values
  const initialValues = {
    // Classification group Initial Values
    iv_consumer_id: '',
    iv_reference_number: '',
    iv_circle: '',
    iv_division: '',
    iv_sub_divison: '',
    iv_address: '',
    // Payment plan field
    iv_payment_plan: 1,
    // Applicant Details group Initial Values
    iv_applicant_name: '',
    iv_father_name: '',
    iv_applicant_cnic: '',
    iv_applicant_phone_no: '',
    iv_applicant_email: '',
    // Required Documents Initial Values
    iv_applicant_cnic_document: null,
    iv_last_paid_bill: null,
    iv_connection_type: '',
    iv_tariff_description: '',
    iv_tariff_code: '',
    iv_meter_type: '',
    iv_phase: ''
  }
  let subDivisionsArray = JSON.parse(
    window.localStorage.getItem("subDivisions")
  );
  //#endregion

  //#region states
  // Classification Group States
  const [referenceNumber, setReferenceNumber] = useState('');
  const [subDivision, setSubDivision] = React.useState({ code: null, name: '' });
  const [dueDate, setDuedate] = useState('')
  const [address, setAddress] = useState('');
  const [connectionType, setConnectionType] = useState('');
  const [billAmount, setBillAmount] = useState('')
  const [extendedDate, setExtendedDate] = useState('');
  const [maxExtendableDueDate, setMaxExtendableDueDate] = useState('');

  const [viewBackdrop, setViewBackdrop] = useState(false);
  const [applicationId, setApplicationId] = useState();
  // States for hiding conditional fields
  const [hierarchyList, setHierarchyList] = useState([]);
  const [noOfDaysToExtend, setNoOfDaysToExtend] = useState(1);
  const navigate = useNavigate()
  const [error, setError] = useState();
  const [circleList, setCircleList] = useState([]);
  const [divisionList, setDivisionList] = useState([]);
  const [subDivisionList, setSubDivisionList] = useState([]);
  const [defaultCircle, setDefaultCircle] = useState();
  const [defaultDivision, setDefaultDivision] = useState();
  const [dueDateExtensionPopUp, setDueDateExtensionPopUp] = useState(false);
  const [customerId, setCustomerId] = useState(null);
  const [billMonth, setBillMonth] = useState(null);
  const [tariff, setTariff] = useState(null);
  const [tariffDesc, setTariffDesc] = useState(null);
  const [ccCode, setCcCode] = useState(null)
  const [availableDays, setAvailableDays] = useState([]);
  const [ddeProvisions, setDdeProvisions] = useState();
  const [searchBy, setSearchBy] = useState('referenceNo');
  const [netBill, setNetBill] = useState('');
  const [lps, setLps] = useState('');
  const [previousLps, setPreviousLps] = useState('');

  const [claimedPayment, setClaimedPayment] = useState('');
  const [claimedPaymentError, setClaimedPaymentError] = useState('');

  const [payment13, setPayment13] = useState('');
  const [payment12, setPayment12] = useState('');
  const [paymentDate, setPaymentDate] = useState(moment());
  const [adjustBillPopup, setAdjustBillPopup] = useState(false);
  const [adjustBillId, setAdjustBillId] = useState('');

  const [gbHistAss13, setGbHistAss13] = useState('');
  const [gbHistAss12, setGbHistAss12] = useState('');

  const [gbHistMonth13, setGbHistMonth13] = useState('');
  const [gbHistMonth12, setGbHistMonth12] = useState('');

  const [applicantCnicDocumentFront, setApplicantCnicDocumentFront] = useState("");
  const [applicantCnicDocumentBack, setApplicantCnicDocumentBack] = useState("");
  // const [nearByBillDocument, setNearByBillDocument] = useState("");
  const [applicantCnicDocumentFrontThumbnail, setApplicantCnicDocumentFrontThumbnail,] = useState("");
  const [applicantCnicDocumentBackThumbnail, setApplicantCnicDocumentBackThumbnail,] = useState("");
  const [nearByBillDocumentThumbnail, setNearByBillDocumentThumbnail] = useState("");
  const [applicantCnicFrontError, setApplicantCnicFrontError] = useState('')
  const [applicantCnicBackError, setApplicantCnicBackError] = useState('')
  const [nearByBillError, setNearByBillError] = useState('')
  const [nearByBillDocument, setNearByBillDocument] = useState("");
  const [paymentDateError, setPaymentDateError] = useState('');
  //#endregion
  const getWaterMarkLogo = (code) => {
    switch (code) {
      case '11':
        return LESCOWaterMark
      case '12':
        return GEPCOWaterMark
      case '13':
        return FESCOWaterMark
      case '14':
        return IESCOWaterMark
      case '15':
        return MEPCOWaterMark
      case '26':
        return PESCOWaterMark
      case '27':
        return HAZECOWaterMark
      case '37':
        return HESCOWaterMark
      case '38':
        return SEPCOWaterMark
      case '48':
        return QESCOWaterMark
      case '59':
        return TESCOWaterMark
      default:
        return MEPCOWaterMark
    }
  }
  const getLogo = (code) => {
    switch (code) {
      case '10':
        return pitcLogo
      case '11':
        return LESCOLOGO
      case '12':
        return GEPCOLOGO
      case '13':
        return FESCOLOGO
      case '14':
        return IESCOLOGO
      case '15':
        return MEPCOLOGO
      case '26':
        return PESCOLOGO
      case '27':
        return HAZECOLOGO
      case '37':
        return HESCOLOGO
      case '38':
        return SEPCOLOGO
      case '48':
        return QESCOLOGO
      case '59':
        return TESCOLOGO
      case '91':
        return SUNDARLOGO
      default:
        return MEPCOLOGO
    }
  }
  //#region local storage
  const { token, code: userCode, userId, cfcLevelId, csc, permissions, currentDateTime } = useSelector((state) => state.auth);
  let subDivList = JSON.parse(window.localStorage.getItem("subDivisions"));
  let userCompany = userCode.slice(0, 2);
  //#endregion

  const formatMonthToDate = (monthStr) => {
    if (!monthStr) return "";

    const [mon, yr] = monthStr.split("-");
    const monthMap = {
      Jan: "01", Feb: "02", Mar: "03", Apr: "04",
      May: "05", Jun: "06", Jul: "07", Aug: "08",
      Sep: "09", Oct: "10", Nov: "11", Dec: "12"
    };

    return `20${yr}-${monthMap[mon]}-01`;
  };




  //#region formik
  const { values, errors, touched, handleBlur, handleChange, handleSubmit, resetForm,submitCount  } =
    useFormik({
      initialValues,
      validationSchema: Yup.object().shape({
        // Classification group Validations
        iv_reference_number: Yup.string().when('iv_search_by', {
          is: () => searchBy === 'referenceNo',
          then: Yup.string().min(14, 'Reference No. must be 14 digits.').max(14, 'Reference No. must be 14 digits.').required("Enter reference number."),
          otherwise: Yup.string().optional()
        }),
        iv_consumer_id: Yup.string().when('iv_search_by', {
          is: () => searchBy === 'consumerId',
          then: Yup.string().min(10, 'Customer ID. must be 10 digits.').max(10, 'Customer ID. must be 10 digits.').required("Enter consumer Id."),
          otherwise: Yup.string().optional()
        }),
        iv_circle: Yup.mixed().required("Please select a circle."),
        iv_division: Yup.mixed().required("Please select a division."),
        iv_sub_divison: Yup.mixed().required("Please select a sub division."),

        // Applicant Details group Validations
        // iv_applicant_name: Yup.string().min(3, "Name should be atleast 3 characters.").max(30, "Name should be less than 30 characters.").required("Please enter applicant name."),
        // iv_applicant_cnic: Yup.string().min(13, "Please enter 13 digit CNIC.").max(13, "Please enter 13 digit CNIC.").required("Please enter valid CNIC number.").matches(/^[0-9]+$/, "Enter CNIC number as 3520212345678."),
        iv_applicant_phone_no: Yup.string().max(11, "Please enter 11 digit phone number.").min(11, "Please enter 11 digit phone number.").required("Please enter valid mobile number.").matches(/^03[0-9]{2}[0-9]{7}$/, "Enter Phone number as 03001234567"),
        // iv_applicant_email: Yup.string().email("Enter email as 'john@gmail.com'.").notRequired(),
        // Required Documents Validation

      }),
      onSubmit: async (values, { resetForm }) => {
        // Validate required documents and fields
        let hasError = false;

        if (!applicantCnicDocumentFront) {
          setApplicantCnicFrontError('CNIC Front image is required');
          hasError = true;
        } else {
          setApplicantCnicFrontError('');
        }

        if (!applicantCnicDocumentBack) {
          setApplicantCnicBackError('CNIC Back image is required');
          hasError = true;
        } else {
          setApplicantCnicBackError('');
        }

        if (!claimedPayment || claimedPayment.replace(/,/g, '') === '0') {
          setClaimedPaymentError('Claimed Payment is required');
          hasError = true;
        } else {
          setClaimedPaymentError('');
        }

        if (hasError) {
          return; // Stop submission if validation fails
        }

        console.log('Form submission started...');
        setViewBackdrop(true)
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
          referenceNo: referenceNumber,
          customerId: customerId,
          applicationProgressId: 1,
          submittedThrough: "e-Operations",
          applicantName: values.iv_applicant_name,
          applicantCNIC: values.iv_applicant_cnic,
          applicantPhone: values.iv_applicant_phone_no,
          applicantEmail: "",
          applicantAddress: address,
          partPaymentAmount: claimedPayment
            ? Number(claimedPayment.replace(/,/g, ""))
            : 0,
          currentBillMonth: formatMonthToDate(gbHistMonth13),   // Dec-25 → 2025-12-01
          currentBillDueDate: dueDate,
          currentBillAmount: gbHistAss13,
          currentBillLps: lps,
          applicantCNICFront: applicantCnicDocumentFrontThumbnail,
          applicantCNICBack: applicantCnicDocumentBackThumbnail,
          tariffCode: tariff,
          cfcId: csc,
          tariffDesc: tariffDesc,
          ccCode: ''
        });

        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow"
        };

        fetch(cfpBaseUrl + "billAdjustment/partPayment/register", requestOptions)
          .then((response) => response.json())
          .then((result) => {
            if (result.status === "200") {
              setViewBackdrop(false)
              const applicationID = result.applicationId;
              printApplicationReceipt(values, applicationID, userId, referenceNumber, claimedPayment);
              setAdjustBillPopup(true);
              setAdjustBillId(result.applicationId)
            } else if (result.status === "400") {
              setViewBackdrop(false)
              setError(result.message || "Request failed. Please try again.");
            } else {
              setViewBackdrop(false)
              setError(result.message || "Something went wrong. Please try again.");
            }
          })
          .catch((error) => {
            console.error(error);
            setViewBackdrop(false);
            setError("Network error. Please try again.");
          });
      }
    })

  useEffect(() => {
    let startDate = new Date(dueDate);
    let futureDate = addBusinessDays(startDate, noOfDaysToExtend);

    const year = futureDate.getFullYear();
    const month = ('0' + (futureDate.getMonth() + 1)).slice(-2);
    const day = ('0' + futureDate.getDate()).slice(-2);
    const formattedDate = `${year}-${month}-${day}`;
    setExtendedDate(formattedDate ? formattedDate : '-');
  }, [dueDate, noOfDaysToExtend])


  useEffect(() => {
    let startDate = new Date(dueDate);
    let futureDate = addBusinessDays(startDate, 10);

    const year = futureDate.getFullYear();
    const month = ('0' + (futureDate.getMonth() + 1)).slice(-2);
    const day = ('0' + futureDate.getDate()).slice(-2);
    const formattedDate = `${year}-${month}-${day}`;
    setMaxExtendableDueDate(formattedDate ? formattedDate : '-');
  }, [dueDate])


  useEffect(() => {
    const loadSubDivs = async () => {
      if (userCompany && cfpBaseUrl && token) {
        setViewBackdrop(true)
        const lists = await subDivAPI(subDivList)
        setHierarchyList(lists.hierarchyList)
        setCircleList(lists.circleList)
        setDivisionList(lists.divisionList)
        setSubDivisionList(lists.subDivisionList)
        setViewBackdrop(false)
      }
    }
    loadSubDivs()
  }, []);

  useEffect(() => {
    if (!hierarchyList || !defaultCircle) return;

    const uniqueDivisions = hierarchyList
      .filter(division => division.circleCode === defaultCircle.code)
      .reduce((uniqueDivisions, division) => {
        const existingDivision = uniqueDivisions.find(d => d.code === division.divisionCode);
        if (!existingDivision) {
          uniqueDivisions.push({
            code: division.divisionCode,
            name: division.divisionName,
          });
        }
        return uniqueDivisions;
      }, []);

    const sortedDivisionArray = uniqueDivisions.sort((a, b) => a.name.localeCompare(b.name, 'en', { ignorePunctuation: true }));

    setDivisionList(sortedDivisionArray);
  }, [defaultCircle, hierarchyList]);

  useEffect(() => {
    if (!defaultDivision || !hierarchyList) return;

    const uniqueSubDivisions = hierarchyList
      .filter(subDivision => subDivision.divisionCode === defaultDivision.code)
      .reduce((uniqueSubDivisions, subDivision) => {
        const existingSubDivision = uniqueSubDivisions.find(s => s.code === subDivision.subDivisionCode);
        if (!existingSubDivision) {
          uniqueSubDivisions.push({
            code: subDivision.subDivisionCode,
            name: subDivision.subDivisionName,
          });
        }
        return uniqueSubDivisions;
      }, []);

    const sortedSubDivisionArray = uniqueSubDivisions.sort((a, b) => a.name.localeCompare(b.name, 'en', { ignorePunctuation: true }));

    setSubDivisionList(sortedSubDivisionArray);
  }, [defaultDivision, hierarchyList]);


  useEffect(() => {
    if (referenceNumber && referenceNumber.length === 14) {
      let enteredReferenceNo = referenceNumber;
      let circleCode = enteredReferenceNo.slice(2, 5);
      let circleObject = circleList.find(item => item.code === parseInt(circleCode));

      if (!circleObject) {
        // Handle circle not found
        console.error(`Circle not found with code: ${circleCode}. Contact Admin!`);
        setError(`Circle not found with code: ${circleCode}`);
        return;
      }

      setDefaultCircle(circleObject);
      values.iv_circle = circleObject.code;

      let divisionCode = enteredReferenceNo.slice(2, 6);
      let subDivisionCode = enteredReferenceNo.slice(2, 7);

      let uniqueDivisions = [];

      for (let i = 0; i < hierarchyList.length; i++) {
        const division = hierarchyList[i];
        if (division.circleCode === parseInt(circleCode)) {
          const existingDivision = uniqueDivisions.find(c => c.code === division.divisionCode);
          if (!existingDivision) {
            uniqueDivisions.push({
              code: division.divisionCode,
              name: division.divisionName,
            });
          }
        }
      }

      let sortedDivisionArray = uniqueDivisions.sort((a, b) =>
        a.name.localeCompare(b.name, undefined, { sensitivity: "base" })
      );
      let defDivision = sortedDivisionArray.find(item => item.code === parseInt(divisionCode));

      if (!defDivision) {
        // Handle division not found
        console.error(`Division not found with code: ${divisionCode}`);
        setError(`Division not found with code: ${divisionCode}. Contact Admin!`);
        return;
      }

      setDefaultDivision(defDivision);
      values.iv_division = defDivision.code;
      setDivisionList(sortedDivisionArray);

      let uniqueSubDivisions = [];

      for (let i = 0; i < hierarchyList.length; i++) {
        const subDivision = hierarchyList[i];
        if (subDivision.divisionCode === parseInt(divisionCode)) {
          const existingSubDivision = uniqueSubDivisions.find(c => c.code === subDivision.subDivisionCode);
          if (!existingSubDivision) {
            uniqueSubDivisions.push({
              code: subDivision.subDivisionCode,
              name: subDivision.subDivisionName,
            });
          }
        }
      }

      let sortedSubDivisionArray = uniqueSubDivisions.sort((a, b) =>
        a.name.localeCompare(b.name, undefined, { sensitivity: "base" })
      );

      let subDivisionObject = sortedSubDivisionArray.find(item => item.code === parseInt(subDivisionCode));
      if (!subDivisionObject) {
        // Handle subdivision not found
        console.error(`Subdivision not found with code: ${subDivisionCode}`);
        setError(`Subdivision not found with code: ${subDivisionCode}. Contact Admin!`);
        return;
      }

      values.iv_sub_divison = subDivisionObject.code;
      setSubDivision(subDivisionObject);
      setSubDivisionList(sortedSubDivisionArray);
    }
  }, [referenceNumber]);

  useEffect(() => {
    if (values.iv_consumer_id.length === 10) {
      referenceApi(); // function to fetch current information on behalf of reference number
    }
    else {
      setDefaultCircle('')
      setDefaultDivision('')
      setSubDivision('')
      setAddress('')
      setConnectionType('')
      setError('')
      setGbHistAss13('')
      setGbHistAss12('')
      setGbHistMonth13('')
      setGbHistMonth12('')
      setPayment13('')
      setPayment12('')
      setNetBill('')
      setLps('')
      setPreviousLps('')
      values.iv_circle = ''
      values.iv_division = ''
      values.iv_sub_divison = ''
      values.iv_reference_number = ''
      values.iv_applicant_name = ''
      values.iv_applicant_cnic = ''
      values.iv_applicant_phone_no = ''
      values.iv_applicant_email = ''
      values.iv_connection_type = ''
      values.iv_meter_type = ''
      values.iv_phase = ''
      values.iv_tariff_code = ''
      values.iv_tariff_description = ''
      values.iv_father_name = ''
      setReferenceNumber()
      setBillAmount('')
      setDuedate('')
      setNoOfDaysToExtend(1)
      setError('')
      setBillMonth(null)
      setTariff(null)
      setTariffDesc(null)
      setCcCode(null)
      setCustomerId(null)
      // Clear documents
      setApplicantCnicDocumentFront('')
      setApplicantCnicDocumentBack('')
      setNearByBillDocument('')
      setApplicantCnicDocumentFrontThumbnail('')
      setApplicantCnicDocumentBackThumbnail('')
      setNearByBillDocumentThumbnail('')
      setApplicantCnicFrontError('')
      setApplicantCnicBackError('')
      setNearByBillError('')
      // Clear payment fields
      setPaymentDate('')
      setClaimedPayment('')
      setPaymentDateError('')
      setClaimedPaymentError('')
    }
  }, [values.iv_consumer_id])

  useEffect(() => {
    // Always clear payment fields and documents when reference number changes
    setPaymentDate('')
    setClaimedPayment('')
    setPaymentDateError('')
    setClaimedPaymentError('')
    // Clear documents
    setApplicantCnicDocumentFront('')
    setApplicantCnicDocumentBack('')
    setNearByBillDocument('')
    setApplicantCnicDocumentFrontThumbnail('')
    setApplicantCnicDocumentBackThumbnail('')
    setNearByBillDocumentThumbnail('')
    setApplicantCnicFrontError('')
    setApplicantCnicBackError('')
    setNearByBillError('')

    if (values.iv_reference_number.length === 14) {
      referenceApi(); // function to fetch current information on behalf of reference number
    } else {
      setDefaultCircle('')
      setDefaultDivision('')
      setSubDivision('')
      setAddress('')
      setGbHistAss13('')
      setGbHistAss12('')
      setGbHistMonth13('')
      setGbHistMonth12('')
      setPayment13('')
      setPayment12('')
      setNetBill('')
      setLps('')
      setPreviousLps('')
      setConnectionType('')
      setError('')
      values.iv_circle = ''
      values.iv_division = ''
      values.iv_sub_divison = ''
      values.iv_consumer_id = ''
      values.iv_applicant_name = ''
      values.iv_applicant_cnic = ''
      values.iv_applicant_phone_no = ''
      values.iv_applicant_email = ''
      values.iv_connection_type = ''
      values.iv_meter_type = ''
      values.iv_phase = ''
      values.iv_tariff_code = ''
      values.iv_tariff_description = ''
      values.iv_father_name = ''
      values.iv_address = ''
      setReferenceNumber()
      setBillAmount('')
      setDuedate('')
      setNoOfDaysToExtend(1)
      setError('')
      setBillMonth(null)
      setTariff(null)
      setTariffDesc(null)
      setCcCode(null)
      setCustomerId(null)
      // Clear documents
      setApplicantCnicDocumentFront('')
      setApplicantCnicDocumentBack('')
      setNearByBillDocument('')
      setApplicantCnicDocumentFrontThumbnail('')
      setApplicantCnicDocumentBackThumbnail('')
      setNearByBillDocumentThumbnail('')
      setApplicantCnicFrontError('')
      setApplicantCnicBackError('')
      setNearByBillError('')
      // Clear payment fields
      setPaymentDate('')
      setClaimedPayment('')
      setPaymentDateError('')
      setClaimedPaymentError('')
    }
  }, [values.iv_reference_number])

  


  useEffect(() => {
    const getProvisions = async () => {
      let provisions = await getPermissions(token, 7);

      setDdeProvisions(provisions)
    }
    getProvisions()
  }, [])
  //#endregion 

  //#region API functions
  // Function to get PTW OAuth token
  const getPTWToken = async () => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

    const urlencoded = new URLSearchParams();
    urlencoded.append("username", "enc");
    urlencoded.append("password", "enc#159");
    urlencoded.append("grant_type", "password");

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow"
    };

    try {
      const response = await fetch(`${ptwBaseUrl}/oauth/token`, requestOptions);
      const result = await response.json();
      return result.access_token;
    } catch (error) {
      console.error("PTW Token Error:", error);
      return null;
    }
  };

  // Function to fetch consumer data from PTW API
  const fetchPTWConsumerData = async (searchValue) => {
    try {
      // First get the token
      const accessToken = await getPTWToken();
      if (!accessToken) {
        console.error("Failed to get PTW token");
        return null;
      }

      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${accessToken}`);

      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow"
      };

      const response = await fetch(`${ptwBaseUrl}/Consumer/${searchValue}`, requestOptions);
      const result = await response.json();
      return result;
    } catch (error) {
      console.error("PTW API Error:", error);
      return null;
    }
  };

  // Helper function to format bill month from API response
  const formatBillMonth = (dateStr) => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return `${months[date.getMonth()]}-${date.getFullYear().toString().slice(-2)}`;
  };

  // Helper function to get tariff description based on tariff code
  const getTariffDescription = (tariffCode) => {
    const tariffMap = {
      '01': 'Domestic',
      '02': 'Commercial',
      '03': 'Commercial',
      '04': 'Industrial',
      '05': 'Bulk Supply',
      '06': 'Agricultural Tube Wells',
      '07': 'Street Lighting',
      '08': 'Residential Colonies',
    };
    return tariffMap[tariffCode] || 'General';
  };

  // Function to fetch sub division and near by name and address through API
  const referenceApi = async () => {
    const searchValue = searchBy === 'consumerId' ? values.iv_consumer_id : values.iv_reference_number;

    if (searchBy === 'consumerId' && !values.iv_consumer_id) return;
    if (searchBy === 'referenceNo' && !values.iv_reference_number) return;

    setViewBackdrop(true);

    try {
      const ptwData = await fetchPTWConsumerData(searchValue);

      if (ptwData && ptwData.Ref_No) {
        setError('');

        // Set address
        const fullAddress = [ptwData.Address, ptwData.Sec_Addres].filter(Boolean).join(', ');
        setAddress(fullAddress);
        values.iv_address = fullAddress;

        // Set reference number
        setReferenceNumber(ptwData.Ref_No);

        // Set applicant details
        values.iv_applicant_name = ptwData.Customer_Name || '';
        values.iv_father_name = ptwData.SWDO || '';
        values.iv_applicant_cnic = ptwData.CNIC || '';
        values.iv_applicant_phone_no = ptwData.CONTACT_NO ? ptwData.CONTACT_NO.replace(/^92/, '0') : '';
        values.iv_applicant_email = ptwData.Email || '';

        // Set connection details
        values.iv_tariff_code = ptwData.Tariff || '';
        values.iv_tariff_description = getTariffDescription(ptwData.Tariff);
        values.iv_meter_type = ptwData.meter_type || '';
        values.iv_phase = ptwData.san_load ? (parseInt(ptwData.san_load) > 5 ? 'Three Phase' : 'Single Phase') : '';
        values.iv_connection_type = getTariffDescription(ptwData.Tariff);
        setConnectionType(getTariffDescription(ptwData.Tariff));

        // Set IDs
        setCustomerId(ptwData.Customer_ID || ptwData.APP_NO);
        setTariff(ptwData.Tariff);
        setTariffDesc(ptwData.Tariff);
        setCcCode(ptwData.SDiv_CD ? ptwData.SDiv_CD.slice(0, 4) : "1501");

        // Set bill month
        const billMonth = formatBillMonth(ptwData.b_month);
        setBillMonth(billMonth);
        setGbHistMonth13(billMonth);

        // Calculate previous month
        if (ptwData.b_month) {
          const bDate = new Date(ptwData.b_month);
          bDate.setMonth(bDate.getMonth() - 1);
          setGbHistMonth12(formatBillMonth(bDate.toISOString()));
        }

        // Set due date (assuming 20 days from bill month)
        if (ptwData.b_month) {
          const dueDate = new Date(ptwData.b_month);
          dueDate.setDate(dueDate.getDate() + 20);
          setDuedate(dueDate.toISOString().slice(0, 10));
        }

        // For billing amounts, we still need dBillAPI or set placeholder values
        // Calling dBillAPI for billing history
        const apiResponse = await dBillAPI(token, searchValue);
        if (apiResponse && apiResponse.histInfo) {
          const histInfo = apiResponse.histInfo;
          const basicInfo = apiResponse.basicInfo;

          setGbHistAss13(histInfo.gbHistAssment13 ? histInfo.gbHistAssment13.replace(/,/g, '') : '0');
          setGbHistAss12(histInfo.gbHistAssment12 ? histInfo.gbHistAssment12.replace(/,/g, '') : '0');
          setGbHistMonth13(histInfo.gbHistMM13 ? histInfo.gbHistMM13 : billMonth);
          setGbHistMonth12(histInfo.gbHistMM12 ? histInfo.gbHistMM12 : '');

          setNetBill(basicInfo?.netBill ? basicInfo.netBill.replace(/,/g, '') : '0');
          setLps(basicInfo?.LatePaymentSurcharge ? basicInfo.LatePaymentSurcharge.replace(/,/g, '') : '0');
          setBillAmount(basicInfo?.netBill ? numberFormatting(basicInfo.netBill) : '0');

          const assessment12 = histInfo.gbHistAssment12
            ? parseInt(histInfo.gbHistAssment12.replace(/,/g, ''), 10)
            : 0;
          const lps12 = Math.round(assessment12 * 0.10);
          setPreviousLps(lps12.toString());

          setPayment13(histInfo.payment13 ? histInfo.payment13.replace(/,/g, '') : '0');
          setPayment12(histInfo.payment12 ? histInfo.payment12.replace(/,/g, '') : '0');
        }

      } else {
        setError(searchBy === 'consumerId'
          ? 'No Data Found against this Customer ID.'
          : 'No Data Found against this Reference No.');
      }
    } catch (error) {
      console.error("API Error:", error);
      setError('Network Error. Please try again.');
    }

    setViewBackdrop(false);
  };
  //#endregion

  //#region functions

  const SearchBy = (event) => {
    values.iv_search_by = event.target.value;
    setSearchBy(event.target.value);
    setDefaultCircle('')
    setDefaultDivision('')
    setSubDivision('')
    setAddress('')
    setConnectionType('')
    setError('')
    setGbHistAss13('')
    setGbHistAss12('')
    setGbHistMonth13('')
    setGbHistMonth12('')
    setPayment13('')
    setPayment12('')
    setNetBill('')
    setLps('')
    setPreviousLps('')
    resetForm()
    values.iv_connection_type = ''
    values.iv_tariff_code = ''
    values.iv_tariff_description = ''
    values.iv_circle = ''
    values.iv_division = ''
    values.iv_sub_divison = ''
    values.iv_consumer_id = ''
    values.iv_applicant_name = ''
    values.iv_applicant_cnic = ''
    values.iv_applicant_phone_no = ''
    values.iv_applicant_email = ''
    values.iv_meter_type = ''
    values.iv_phase = ''
    values.iv_address = ''
    setReferenceNumber()
    setBillAmount('')
    setDuedate('')
    setNoOfDaysToExtend(1)
    setError('')
    setBillMonth(null)
    setTariff(null)
    setTariffDesc(null)
    setCcCode(null)
    setCustomerId(null)
    // Clear payment fields
    setPaymentDate('')
    setClaimedPayment('')
    setPaymentDateError('')
    setClaimedPaymentError('')
  };

  const printApplicationReceipt = (values, applicationID, userId, referenceNo, claimedPaymentAmount) => {
    let DiscoCode = values.iv_sub_divison.toString().slice(0, 2);
    const doc = new jsPDF({ compressPdf: true });
    // Generate the barcode image using JsBarcode
    const barcodeCanvas = document.createElement("canvas");
    JsBarcode(barcodeCanvas, applicationID);

    // Convert the barcode image to data URL
    const barcodeDataURL = barcodeCanvas.toDataURL("image/png");
    var height = 10;
    var padding = 10;
    const smallLogoCodes = ['12', '13', '11', '16', '26', '27', '48', '59'];
    var pageWidth = doc.internal.pageSize.getWidth();

    const logoWidth = smallLogoCodes.includes(DiscoCode) ? 25 : 30;
    const logoHeight = smallLogoCodes.includes(DiscoCode) ? 15 : 8;
    // Get page width

    // Calculate X position to center the logo
    const logoX = (pageWidth - logoWidth) / 2;
    // Add the barcode image to the PDF document
    doc.addImage(barcodeDataURL, "PNG", 85, 260, 40, 20); // Adjust the position and size of the barcode image
    doc.addImage(getLogo(DiscoCode), "PNG", logoX, height, logoWidth, logoHeight); // Adjust the position and size of the barcode image

    if (DiscoCode === '91') {
      height = height + 30;
    } else {
      height = height + 20;
    }

    var increment = 10;
    doc.setFontSize(15);
    doc.setFont("helvetica", "bold");
    doc.text(
      "Receipt of Part Payment Request",
      doc.internal.pageSize.getWidth() / 2,
      height,
      {
        align: "center",
      }
    );
    doc.setFontSize(12);
    increment = 20;
    height = height + increment;
    var leftMargin = 120;
    doc.text("DISCO / Company: ", padding, height);
    doc.text("Sub Division Code & Name:", padding + leftMargin, height);

    doc.setFont("helvetica", "normal");
    increment = 10;
    height = height + increment;
    leftMargin = 120;
    doc.text(
      companyShortName(values.iv_circle.toString().slice(0, 2)),
      padding,
      height
    );
    doc.text(
      values.iv_sub_divison.toString() +
      " / " +
      subdivisionName(values.iv_sub_divison, subDivisionsArray),
      // 'Sub Division Name',
      padding + leftMargin,
      height
    );

    increment = 10;
    height = height + increment;
    leftMargin = 40;
    doc.setFont("helvetica", "bold");
    doc.text("Tracking ID: ", padding, height);
    doc.setFont("helvetica", "normal");
    doc.text(applicationID.toString(), padding + leftMargin, height);
    leftMargin = 100;
    doc.setFont("helvetica", "bold");
    doc.text("Application Date: ", padding + leftMargin, height);
    doc.setFont("helvetica", "normal");
    leftMargin = 150;
    // Get the current date
    var currentDate = new Date();
    var formattedDate = currentDate.getDate() + ' ' +
      ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][currentDate.getMonth()] + ' ' +
      currentDate.getFullYear();
    doc.text(formattedDate, padding + leftMargin, height);

    increment = 10;
    height = height + increment;
    leftMargin = 40;
    doc.setFont("helvetica", "bold");
    doc.text("Reference No: ", padding, height);
    doc.setFont("helvetica", "normal");
    doc.text(referenceNo, padding + leftMargin, height);
    leftMargin = 100;
    doc.setFont("helvetica", "bold");



    increment = 10;
    height = height + increment;
    leftMargin = 40;
    doc.setFont("helvetica", "bold");
    doc.text("Applicant Name: ", padding, height);
    doc.setFont("helvetica", "normal");
    doc.text(values.iv_applicant_name, padding + leftMargin, height);
    leftMargin = 100;
    doc.setFont("helvetica", "bold");
    doc.text("Mobile No.: ", padding + leftMargin, height);
    leftMargin = 130;
    doc.setFont("helvetica", "normal");
    doc.text(values.iv_applicant_phone_no, padding + leftMargin, height);

    increment = 10;
    height = height + increment;
    leftMargin = 40;
    doc.setFont("helvetica", "bold");
    doc.text("Issued By: ", padding, height);
    doc.setFont("helvetica", "normal");
    doc.text(userId, padding + leftMargin, height);
    leftMargin = 100;
    doc.setFont("helvetica", "bold");
    doc.text("Claimed Payment: ", padding + leftMargin, height);
    leftMargin = 145;
    doc.setFont("helvetica", "normal");
    doc.text(claimedPaymentAmount || '-', padding + leftMargin, height);

    const totalPages = doc.internal.getNumberOfPages();

    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      if (userCompany != '91') {
        doc.addImage(
          getWaterMarkLogo(userCompany),
          "PNG",
          0,
          0,
          doc.internal.pageSize.getWidth(),
          doc.internal.pageSize.getHeight()
        );
      }

    }

    const pdfBlob = doc.output('blob');
    const pdfDataUrl = URL.createObjectURL(pdfBlob);

    // Open the PDF in a new tab
    window.open(pdfDataUrl, '_blank');

  };

  const handleClose = () => {
    setDueDateExtensionPopUp(false);
    navigate('/amend-2636-bill-table');
  };

  const errorCloses = () => {
    setError('')
    // setFieldSurveyError('')
  }

  const referedToCFCLevelId = (totalBillAmount, noOfDaysToExtend) => {
    if (ddeProvisions) {
      let referedToCFCLevelId = 0;
      let instProvAccToNos = ddeProvisions.filter((item) => item.noOfActions == noOfDaysToExtend)
      let instProvAccToBillAmount = instProvAccToNos.find((item) => (item.amountFrom <= totalBillAmount) && (item.amountTo >= totalBillAmount))
      if (instProvAccToBillAmount.cfcLevelId) {
        referedToCFCLevelId = instProvAccToBillAmount.cfcLevelId
      }

      return referedToCFCLevelId
    }
  }
  // const referedToCFCLevelId = (totalBillAmount, noOfDaysToExtend) => {
  //   if (ddeProvisions) {
  //     let referedToCFCLevelId = 0;
  //     let instProvAccToNos = ddeProvisions.filter(
  //       (item) => item.noOfActions == noOfDaysToExtend
  //     );

  //     let instProvAccToBillAmount = instProvAccToNos.find(
  //       (item) =>
  //         item.amountFrom <= totalBillAmount && item.amountTo >= totalBillAmount
  //     );

  //     if (instProvAccToBillAmount && instProvAccToBillAmount.cfcLevelId) {
  //       referedToCFCLevelId = instProvAccToBillAmount.cfcLevelId;
  //     } else {
  //       console.warn("⚠️ Could not determine cfcLevelId. Check DDE provisions or bill range.");
  //     }

  //     return referedToCFCLevelId;
  //   }
  //   return 0; // fallback return if ddeProvisions is undefined
  // };


  const getFinalCFCLevelId = (initialReferedToCFCId, loggedInUserCFCId) => {
    if (initialReferedToCFCId && loggedInUserCFCId) {
      if (initialReferedToCFCId == loggedInUserCFCId) {
        return initialReferedToCFCId
      } else if (loggedInUserCFCId > initialReferedToCFCId) {
        return initialReferedToCFCId
      } else if (loggedInUserCFCId < initialReferedToCFCId) {
        return loggedInUserCFCId
      }
    }
  }

  const getOfficeCode = (referedToCFCLevelId, referenceNo) => {
    let officeCode = ''
    if (referedToCFCLevelId == 2) {
      officeCode = referenceNo.slice(2, 4)
    } else if (referedToCFCLevelId == 3) {
      officeCode = referenceNo.slice(2, 5)
    } else if (referedToCFCLevelId == 4) {
      officeCode = referenceNo.slice(2, 6)
    } else if (referedToCFCLevelId == 5) {
      officeCode = referenceNo.slice(2, 7)
    }
    return officeCode
  }

  const getRelevantCFCId = async (totalBill, noOfInst, referenceNo) => {
    // if (!ddeProvisions) return '';

    let referedToCFCId = '';
    let initialLevelId = referedToCFCLevelId(parseInt(totalBill.replace(/,/g, '')), noOfInst);

    if (!initialLevelId) {
      console.warn("⚠️ initialReferedToCFCLevelId not found, fallback to userCode.");
      return userCode;
    }

    if (initialLevelId !== parseInt(cfcLevelId)) {
      let finalLevelId = getFinalCFCLevelId(initialLevelId, parseInt(cfcLevelId));
      let officeCode = getOfficeCode(finalLevelId, referenceNo);
      referedToCFCId = await getRelevantCFCCode(token, officeCode, finalLevelId);
    } else {
      referedToCFCId = userCode;
    }

    return referedToCFCId;
  };


  //#endregion

  const [ddeStatusBarArray, setDdeStatusBarArray] = useState([{
    title1: 'APPLICATION',
    title2: 'DETAIL',
    status: 0
  }]);

  useEffect(() => {
    if ((values.iv_consumer_id || values.iv_reference_number) &&
      values.iv_applicant_phone_no &&
      noOfDaysToExtend >= 1
    ) {
      setDdeStatusBarArray(prevArray => {
        const updatedArray = [...prevArray];
        updatedArray[0] = {
          ...updatedArray[0],
          status: 1 // Set the status to the desired value
        };
        return updatedArray;
      })
    }
    else {
      setDdeStatusBarArray(prevArray => {
        const updatedArray = [...prevArray];
        updatedArray[0] = {
          ...updatedArray[0],
          status: 0 // Set the status to the desired value
        };
        return updatedArray;
      })
    }
  }, [values])

  const NearByBillDocument = (event) => {
    if (event.target.files) {
      const newFileName = 'scannedCopyOfNearByElectricityBill.' + event.target.files[0].name.split(".").pop();
      handleFileUpload(event, handleChange, setNearByBillDocument, setNearByBillError, setNearByBillDocumentThumbnail, newFileName);
    }
  };

  const ApplicantCnicDocumentBack = (event) => {
    if (event.target.files) {
      const newFileName = 'copyOfApplicantCNICBack.' + event.target.files[0].name.split(".").pop();
      handleFileUpload(event, handleChange, setApplicantCnicDocumentBack, setApplicantCnicBackError, setApplicantCnicDocumentBackThumbnail, newFileName);
    }
  };
  const ApplicantCnicDocumentFront = (event) => {
    if (event.target.files) {
      const newFileName = 'copyOfApplicantCNICFront.' + event.target.files[0].name.split(".").pop();
      handleFileUpload(event, handleChange, setApplicantCnicDocumentFront, setApplicantCnicFrontError, setApplicantCnicDocumentFrontThumbnail, newFileName);
    }
  };
  return (
    <>
      <Grid container className='nC'>
        <Box className='nCContainer'>
          <div className="headingBarDiv">
            <h3 className="heading">
             Part Payment
            </h3>
            <StepProgressBar array={ddeStatusBarArray} />
          </div>
          <form className='ncform'>
            <Typography variant="h6" className="groupTitle">
              <div className="redCell">
              </div>
              Applicant's Details
            </Typography>
            <CustomerInformationCard
              searchBy={searchBy}
              SearchBy={SearchBy}
              allowedSearchBy={['referenceNo']}
              errors={errors}
              values={values}
              touched={touched}
              handleChange={handleChange}
              handleBlur={handleBlur}
              defaultCircle={defaultCircle}
              circleList={circleList}
              setDefaultCircle={setDefaultCircle}
              defaultDivision={defaultDivision}
              divisionList={divisionList}
              setDefaultDivision={setDefaultDivision}
              subDivision={subDivision}
              subDivisionList={subDivisionList}
              setSubDivision={setSubDivision}
              showSubmitErrors={submitCount > 0}
            />
            <Typography variant="h6" className="groupTitle">
              <div className="cyanCell">
              </div>
              Billing Details
            </Typography>
            <Grid container className='container'>
              <Grid item xs={2} sx={{ paddingRight: '20px' }}>
                <Typography className='fieldLabel'>Current Bill</Typography>
                <TextField
                  type='text'
                  autoComplete='off'
                  value={gbHistAss13 ? numberFormatting(gbHistAss13) : '-'}
                  disabled
                  className='textInputField1'
                />
              </Grid>
            
              <Grid item xs={2} sx={{ paddingRight: '20px' }}>
                <Typography className='fieldLabel'>Current Month</Typography>
                <TextField
                  type='text'
                  autoComplete='off'
                  value={gbHistMonth13 ? gbHistMonth13 : '-'}
                  disabled
                  className='textInputField1'
                />
              </Grid>
            
              <Grid item xs={2} sx={{ paddingRight: '20px' }}>
                <Typography className='fieldLabel'>Current LPS</Typography>
                <TextField
                  type='text'
                  autoComplete='off'
                  value={lps ? numberFormatting(lps) : '-'}
                  disabled
                  className='textInputField1'
                />
              </Grid>
              
              

              <Grid item xs={2} sx={{ paddingRight: '20px'}} >
                <Typography className='fieldLabel'>
                  Part Payment <span style={{ color: 'red' }}>*</span>
                </Typography>
                <TextField
                  type="text"
                  autoComplete='off'
                  value={claimedPayment}
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^0-9]/g, ''); // Only numbers
                    setClaimedPayment(value);
                    if (value) setClaimedPaymentError('');
                  }}
                  onBlur={() => {
                    if (claimedPayment) {
                      setClaimedPayment(numberFormatting(claimedPayment));
                    }
                  }}
                  placeholder="Enter amount"
                  fullWidth
                  className='textInputField1'
                  error={!!claimedPaymentError}
                  inputProps={{ maxLength: 12, style: { backgroundColor: 'white' } }}
                  sx={{
                    backgroundColor: 'white',
                    '& .MuiOutlinedInput-root': {
                      backgroundColor: 'white',
                    },
                    '& .MuiInputBase-input': {
                      backgroundColor: 'white',
                    }
                  }}
                />
                {claimedPaymentError && (
                  <Box sx={{ color: 'red', fontSize: '11px', marginTop: '4px' }}>
                    {claimedPaymentError}
                  </Box>
                )}
              </Grid>
            </Grid>
            <Typography
              variant="h6"
              className="groupTitleDocuments"
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              Required Documents
            </Typography>
            <Grid container spacing={1} className="documentsContainer">
              <Grid item lg={1.25}>
                <Typography className="documentLabel">
                  1- Applicant's CNIC.
                </Typography>
              </Grid>
              <Grid item lg={0.875}>
                {applicantCnicDocumentFront ? (
                  <>
                    <Button
                      varient="outlined"
                      component="label"
                      startIcon={
                        <CloseIcon
                          className="button-with-image"
                          onClick={() => {
                            setApplicantCnicDocumentFront("");
                          }}
                        />
                      }
                    >
                      {applicantCnicDocumentFrontThumbnail &&
                        isImage(applicantCnicDocumentFront) ? (
                        <div className="btn-div">
                          <img
                            src={applicantCnicDocumentFrontThumbnail}
                            alt="Applicant CNIC Front"
                            width="80"
                          />
                          {/* <p>{applicantCnicDocumentFrontFileName}</p> */}
                        </div>
                      ) : (
                        <span>
                          {isPdf(applicantCnicDocumentFront) ? (
                            <div className="btn-div">
                              <img src={pdfIcon} alt="PDF" width="80" />
                              {/* <p>{applicantCnicDocumentFrontFileName}</p> */}
                            </div>
                          ) : (
                            "Other file type"
                          )}
                        </span>
                      )}
                    </Button>
                  </>
                ) : (
                  <>
                    <Button
                      variant="outlined"
                      component="label"
                      startIcon={<FileUploadOutlinedIcon />}
                      className="btn"
                    >
                      Front
                      <input
                        hidden
                        accept={documentExtensions}
                        id="iv_applicant_cnic_document_front"
                        name="iv_applicant_cnic_document_front"
                        type="file"
                        onChange={ApplicantCnicDocumentFront}
                      />
                    </Button>
                    {applicantCnicFrontError && (
                      <Box sx={{ color: 'red', fontSize: '11px', marginTop: '4px' }}>
                        {applicantCnicFrontError}
                      </Box>
                    )}
                  </>
                )}
              </Grid>
              <Grid item lg={0.875}>
                {applicantCnicDocumentBack ? (
                  <>
                    <Button
                      component="label"
                      startIcon={
                        <CloseIcon
                          className="button-with-image"
                          onClick={() => {
                            setApplicantCnicDocumentBack("");
                          }}
                        />
                      }
                    >
                      {applicantCnicDocumentBackThumbnail &&
                        isImage(applicantCnicDocumentBack) ? (
                        <div className="btn-div">
                          <img
                            src={applicantCnicDocumentBackThumbnail}
                            alt="Applicant CNIC Back"
                            width="80"
                          />
                        </div>
                      ) : (
                        <span>
                          {isPdf(applicantCnicDocumentBack) ? (
                            <div className="btn-div">
                              <img src={pdfIcon} alt="PDF" width="80" />
                            </div>
                          ) : (
                            "Other file type"
                          )}
                        </span>
                      )}
                    </Button>
                  </>
                ) : (
                  <>
                    <Button
                      variant="outlined"
                      component="label"
                      startIcon={<FileUploadOutlinedIcon />}
                      className="btn"
                    >
                      Back
                      <input
                        hidden
                        accept={documentExtensions}
                        id="iv_applicant_cnic_document_back"
                        name="iv_applicant_cnic_document_back"
                        type="file"
                        onChange={ApplicantCnicDocumentBack}
                      />
                    </Button>
                    {applicantCnicBackError && (
                      <Box sx={{ color: 'red', fontSize: '11px', marginTop: '4px' }}>
                        {applicantCnicBackError}
                      </Box>
                    )}
                  </>
                )}
              </Grid>

            </Grid>
            {error && (
              <Error
                error={error}
                onClose={() => errorCloses()}
                backgroundColor="#FFC0CB"
                textColor="#bb0303"
                iconColor="#bb0303"
              />
            )}
            <Box sx={{ marginTop: "1%", textAlign: "right", marginRight: '2%', marginBottom: '2%' }}>
              <Button className={((values.iv_consumer_id.length === 10 || values.iv_reference_number.length === 14) && values.iv_applicant_phone_no != '' && noOfDaysToExtend) === false ? 'disabled-button' : 'button'}
                variant="contained" component="label" onClick={handleSubmit} disabled={((values.iv_consumer_id.length === 10 || values.iv_reference_number.length === 14) && noOfDaysToExtend) === false}>
                Submit
              </Button>
            </Box>
          </form >
        </Box >
      </Grid >



      < Dialog
        open={adjustBillPopup}
        onClose={handleClose}
        className='dialog'
        fullWidth={true}
        maxWidth={'sm'}
        PaperProps={{ style: { width: '100%', borderRadius: 20 } }}
      >
        <DialogTitle  >
          <Box className="backgroundAttached" >
            <DoneIcon className="icon" />
          </Box>
          <Typography variant="h6" className="groupTitle"> Application Submitted</Typography>
        </DialogTitle>
        <DialogContent>
          <div className="applicationSubmit">Your Application is submitted successfully.</div>
          <div className="trackIdPara">Your Tracking ID.</div>
          <div className="trackId">{adjustBillId}</div>
        </DialogContent>
        <DialogActions>
        </DialogActions>
      </Dialog >


      {/* Backdrop */}
      < Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000 }}
        open={viewBackdrop}
      >
        <CircularProgress color="inherit" />
      </Backdrop >
    </>
  );
}

export default AmendBill2636Form;